import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';

type BanerProps = {
  $bigBgImage: string;
  $bgImage: string;
  $logo: string;
};

export const BannerLink = styled.a`
  width: 100%;
`;

export const BannerMobileWrapper = styled.div`
  width: 100%;

  @media (max-width: ${device.laptop}) {
    margin-top: 24px;
  }
`;

export const Banner = styled.div<BanerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  width: 100%;

  @media (min-width: ${device.laptop}) {
    padding: 8px 48px;

    background-color: #066bd9;

    background-image: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.6) 0%,
        rgba(255, 255, 255, 0.8) 100%
      ),
      url(${props => props.$bigBgImage});

    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 50%;
  }

  @media (max-width: ${device.laptop}) {
    background-image: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.6) -0.67%,
        rgba(255, 255, 255, 0.8) 99.33%
      ),
      url(${props => props.$bgImage}), linear-gradient(0deg, #066bd9, #066bd9);

    background-position: 0 30%;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 12px;
    padding: 8px;
  }
`;

export const InlineContent = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${device.laptop}) {
    align-items: flex-start;
    width: 100%;
    padding-left: 0;
    padding-right: 0;
    gap: 2px;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Logo = styled.img`
  object-fit: contain;
`;

export const BottomRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 80px;
  align-self: stretch;

  @media (max-width: ${device.laptop}) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;

export const LeftRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Subtitle = styled.span`
  color: #000;
  font-size: 14px;

  @media (max-width: ${device.laptop}) {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0%;
  }
`;

export const Separator = styled.div`
  width: 1px;
  align-self: stretch;
  background: #000;
`;

export const Price = styled.span`
  color: #000;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;

  @media (max-width: ${device.laptop}) {
    font-size: 14px;
    paragraph-spacing: 14px;
  }
`;

export const RightText = styled.div`
  font-style: normal;
  color: black;
  font-size: 12px;

  @media (max-width: ${device.laptop}) {
    display: flex;
    gap: 8px;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0%;
    color: black;
  }
`;

export const DiscountCode = styled.span`
  font-weight: 600;
  line-height: 16px;
  font-size: 12px;
  text-align: right;

  @media (max-width: ${device.laptop}) {
    height: 16px;
    padding: 0 2px;
    background: #000;
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0%;
    border-top-left-radius: 5px;
    border-bottom-right-radius: 8px;
  }
`;
